module.exports = __webpack_public_path__ + "static/ProximaNova-Black-40f852b620d42017697e5985489e6485.woff";